import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MarketingReveal from './MarketingReveal';
import { pageText } from '../../content/publicPages';
import { usePublicPage } from '../../hooks/usePublicPage';

/**
 * Quiet closing band — one job, one CTA (Shopify end-of-page rhythm).
 */
const MarketingClosingCta = () => {
  const { saved, defaults } = usePublicPage('home');
  return (
    <section className="bg-m-canvas-light px-4 py-20 sm:px-6 sm:py-28">
      <MarketingReveal className="mx-auto w-full max-w-5xl text-center">
        <h2 className="marketing-section-title mb-4 text-m-ink">
          {pageText(saved.closing_title, defaults.closing_title)}
        </h2>
        <p className="marketing-body-lg mx-auto mb-10 max-w-xl text-m-ink-muted">
          {pageText(saved.closing_body, defaults.closing_body)}
        </p>
        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link to={pageText(saved.closing_primary_link, defaults.closing_primary_link)} className="marketing-btn marketing-btn-ink gap-2">
            {pageText(saved.closing_primary_label, defaults.closing_primary_label)}
            <ArrowRight className="h-4 w-4" />
          </Link>
          <Link
            to={pageText(saved.closing_secondary_link, defaults.closing_secondary_link)}
            className="inline-flex h-[var(--m-control-h)] items-center justify-center gap-2 rounded-full border border-m-border-light px-6 text-sm font-medium text-m-ink transition-colors hover:border-m-ink"
          >
            {pageText(saved.closing_secondary_label, defaults.closing_secondary_label)}
          </Link>
        </div>
      </MarketingReveal>
    </section>
  );
};

export default MarketingClosingCta;
